import PropTypes from 'prop-types';

import useRepairRequestCorrectionActions from
  '#/modules/crmMgmt/aftersales/repairRequest/hooks/useRepairRequestCorrectionActions';

import RepairRequestCommandBar from './RepairRequestCommandBar';
import RepairRequestDetailTabs from './RepairRequestDetailTabs';
import RepairRequestMainInfoCard from './RepairRequestMainInfoCard';

/** 詳情頁：主資訊卡＋下方分頁（報修明細／更正紀錄）。更正 actions 由 CommandBar 與明細列共用。 */
const RepairRequestBlock = ({
  detail,
  onRefetch,
  showActions = false,
}) => {
  const correctionActions = useRepairRequestCorrectionActions(detail, onRefetch);

  return (
    <>
      {showActions ? correctionActions.dialogs : null}
      <RepairRequestMainInfoCard
        detail={detail}
        actions={
          showActions ? (
            <RepairRequestCommandBar
              key={`${detail.id}-${detail.record?.updatedAt ?? ''}`}
              detail={detail}
              onRefetch={onRefetch}
              correctionActions={correctionActions}
              inDetailPage
            />
          ) : null
        }
      />
      <RepairRequestDetailTabs
        detail={detail}
        correctionActions={showActions ? correctionActions : null}
      />
    </>
  );
};

RepairRequestBlock.propTypes = {
  detail: PropTypes.shape({
    id: PropTypes.string,
    repairRequestNo: PropTypes.string,
    status: PropTypes.string,
    record: PropTypes.shape({
      updatedAt: PropTypes.string,
    }),
    lines: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  onRefetch: PropTypes.func,
  showActions: PropTypes.bool,
};

export default RepairRequestBlock;
